import React from "react";
import { Button, Grid, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { headerStyles } from "./styles";

interface IProps {
  handleCancelEdit(): void;
  isValid: boolean;
}

export const RestaurantEditHeader: React.FC<IProps> = ({
  handleCancelEdit,
  isValid,
}) => {
  const classes = headerStyles();
  const { t } = useTranslation();

  return (
    <>
      <Grid
        container
        justify="space-between"
        alignItems="center"
        className={classes.headerContainer}
      >
        <Grid item>
          <Typography variant="h6">
            {t('restaurant.info.edit.editRestaurant')}
          </Typography>
        </Grid>
        <Grid item>
          <Button
            onClick={handleCancelEdit}
            variant="outlined"
            size="medium"
            className={classes.button}
            style={{ backgroundColor: 'transparent' }}
          >
            {t('app.common.cancel')}
          </Button>
          <Button
            type="submit"
            variant="contained"
            size="medium"
            className={classes.button}
            disabled={!isValid}
          >
            {t('app.common.save')}
          </Button>
        </Grid>
      </Grid>
    </>
  );
};
